export default function PHP_pos() {
  return (
    <div>
      <h1>PHP_pos</h1>
    </div>
  );
}
